import React, { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import FormRegion from '../../primitives/form-region';
import FormFieldset from '../../primitives/form-fieldset';
import StyledButton from '../../primitives/styled-button';
import FormProvider from '../../primitives/form-provider';
import Input from '../../primitives/input';
import Typography from '../../primitives/typography';
import Divider from '../../primitives/divider';
import FormSuccess from '../../primitives/form-success';

interface CovidCleaningFormProps {
    submitButton?: string
    successMessage?: string
}

const CovidCleaningForm = ({ submitButton, successMessage }: CovidCleaningFormProps): JSX.Element => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleFormSubmit = async (data: FieldValues): Promise<void> => {
        try {
            setIsLoading(true);
            const res = await fetch('/api/forms/form-FnolForm', {
                method: 'POST',
                body: JSON.stringify({
                    data,
                }),
            });
            if (res.ok) {
                setShowSuccess(true);
                setIsLoading(false);
            }
        } catch (err) {
            setIsLoading(false);
        }
    };

    return (
        <FormProvider
            onSubmit={handleFormSubmit}
            disabled={isLoading || showSuccess}
        >
            <FormRegion description="">
                <FormFieldset name="Name">
                    <Input
                        name="firstName"
                        placeholder="First name"
                        required
                    />
                    <Input
                        name="lastName"
                        placeholder="First name"
                        required
                    />
                </FormFieldset>
            </FormRegion>
            <FormRegion description="">
                <FormFieldset name="Business Information">
                    <Input
                        name="businessName"
                        placeholder="Business Name"
                        required
                    />
                    <Input
                        name="numberOfLocations"
                        placeholder="Number of Locations"
                        required
                        type="number"
                    />
                </FormFieldset>
            </FormRegion>
            <FormRegion description="">
                <FormFieldset name="Contact Information">
                    <Input
                        name="zipCode"
                        placeholder="Zip Code"
                        required
                    />
                    <Input
                        name="emailAddress"
                        placeholder="Email Address"
                        required
                        type="email"
                    />
                    <Input
                        name="phoneNumber"
                        placeholder="Phone Number"
                        required
                        type="tel"
                    />
                </FormFieldset>
            </FormRegion>
            <FormRegion description="">
                <FormFieldset name="">
                    <StyledButton type="submit" loading={isLoading}>
                        {submitButton || 'Submit'}
                    </StyledButton>
                </FormFieldset>
                <FormFieldset name="">
                    {showSuccess && (
                        <Typography css={{ width: '100%' }} fontSize={{ dt: 'sm' }}>
                            <Divider css={{
                                paddingBottom: '4px',
                            }}
                            />
                            <FormSuccess>
                                {successMessage || 'Submitted successfully.'}
                            </FormSuccess>
                        </Typography>
                    )}
                </FormFieldset>
            </FormRegion>
        </FormProvider>
    );
};

export default CovidCleaningForm;
